export class AbilityPricelistListDTO {

    id: string;

    name: string;

    description: string;

    currency: string;

    defaultForCurrency: boolean;

}
